<template>
  <div ref="rootRef">
    <DSDateField
      :model-value="modelValue ?? undefined"
      :size="toDSInputSize(size)"
      :readonly
      aria-label="Filter value"
      @update:model-value="modelValue = $event ?? null"
    />
  </div>
</template>

<script setup lang="ts">
import { inject, useTemplateRef } from 'vue'

import { InputSize } from '@types'
import { toDSInputSize } from '../../Input/utils/helpers'

import { DSDateField } from '@ds'

type Props = {
  readonly?: boolean
}

defineProps<Props>()

const modelValue = defineModel<string | null>()

defineExpose({
  start() {
    rootRef.value
      ?.querySelector<HTMLElement>(
        '[data-reka-date-field-segment]:not([data-reka-date-field-segment="literal"])',
      )
      ?.focus()
  },
})

const size = inject<InputSize>('size')

const rootRef = useTemplateRef('rootRef')
</script>
